module.exports = __webpack_public_path__ + "static/media/instructor-onboarding-image19.5ac2001d.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-onboarding-image19.png
// module id = 2587
// module chunks = 0